import { render, staticRenderFns } from "./insurance-poster.vue?vue&type=template&id=5e4a8c5d&scoped=true&"
import script from "./insurance-poster.vue?vue&type=script&lang=js&"
export * from "./insurance-poster.vue?vue&type=script&lang=js&"
import style0 from "./insurance-poster.vue?vue&type=style&index=0&id=5e4a8c5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4a8c5d",
  null
  
)

export default component.exports